import { render, staticRenderFns } from "./AccuseDlg.vue?vue&type=template&id=904ff834&"
import script from "./AccuseDlg.vue?vue&type=script&lang=ts&"
export * from "./AccuseDlg.vue?vue&type=script&lang=ts&"
import style0 from "./AccuseDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports